// extracted by mini-css-extract-plugin
export default {"final-step-info":"final-step-info_final-step-info__Lh0n1","final-step-info__text":"final-step-info_final-step-info__text__xdvHp"};